
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/basics",
      function () {
        return require("private-next-pages/ir/governance/basics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/governance/basics"])
      });
    }
  